<div class="flex-container" *ngIf="component === 'customer_notification'">
  <div>
    <h1 class="heading" *ngIf="this.comSvc.lang.includes('en')">Customer Notification:</h1>
    <h1 class="heading" *ngIf="!this.comSvc.lang.includes('en')">고객 알림:</h1>
  </div>

  <div class="mb20">
    <p class="title">
      {{ customer_notif_title }}
    </p>
  </div>

  <div class="mb20">
    <p class="content">
      {{ customer_notif_content }}
    </p>
  </div>

  <div class="mb20">
    <p class="link">
      <a href="{{ customer_notif_link }}" target="_blank">{{ customer_notif_link }}</a>
    </p>
  </div>
</div>

<div class="flex-container" *ngIf="component === 'spectrogram'">
  <div class="images">
    <img src="{{ this.spectrogram }}" alt="No picture found" />
  </div>
</div>

<ng-container *ngIf="component === 'ai'">
  <ng-container *ngIf="this.isJSONobj; else notJSON">
    <div>
      <canvasjs-chart [options]="chartOptions" [styles]="{ width: '100%', height: '360px' }"></canvasjs-chart>
    </div>
  </ng-container>
  <ng-template #notJSON>
    <h1 class="heading_ai flex-table">AI Analysis</h1>
    {{ this.chartAnalysis }}
  </ng-template>
</ng-container>
<ng-container *ngIf="component === 'analysis_result'">
  <ng-container *ngIf="this.isJSONobj; else notJSON">
    <div>
      <canvasjs-chart [options]="chartOptions" [styles]="{ width: '100%', height: '360px' }"></canvasjs-chart>
    </div>
  </ng-container>
  <ng-template #notJSON>
    <h1 class="heading_ai flex-table">Signal Analysis Result</h1>
    {{ this.chartAnalysis }}
  </ng-template>
</ng-container>

<div class="flex col gap20" *ngIf="component === 'show_description'">
  <div>
    <h1 class="flex-table">Description</h1>
  </div>
  <div class="ml20">
    <p>{{ this.description }}</p>
  </div>
</div>

<div class="flex col gap20" *ngIf="component === 'showPrivacyNotice'">
  <div>
    <h1 class="flex-table">Privacy Notice</h1>
  </div>
  <ul class="ml20" *ngFor="let line of privacyNoticeText">
    <li>{{ line }}</li>
  </ul>
</div>

<div class="flex col row-gap20" *ngIf="component === 'approval_submit'">
  <h1 class="popupHeader padding10">Confirmation</h1>
  <div class="padding10">
    <p>Are you sure you want to submit the approval?</p>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-button mat-dialog-close="close">Cancel</button>
    <button mat-raised-button color="primary" mat-dialog-close="true">Yes</button>
  </div>
</div>

<div class="flex col gap20 padding" *ngIf="component === 'service_result'">
  <div>
    <h1 class="flex-table">Service Result</h1>
  </div>
  <div>
    <table mat-table [dataSource]="dataSource">
      <ng-container *ngFor="let col of displayedColumns" [matColumnDef]="col">
        <th mat-header-cell *matHeaderCellDef class="popupHeaderCol">{{ col | translator }}</th>
        <td mat-cell *matCellDef="let element">{{ element[col] }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>

<div class="jss45" *ngIf="this.component === 'PrivacyPolicyComponent'">
  <div class="flex alignCenter spaceBtw">
    <h1>개인정보처리방침</h1>
    <mat-icon class="hoverable" mat-dialog-close>close</mat-icon>
  </div>
  <div>
    <br />
    <!-- 본 시스템의 개인정보처리방침은 인사시스템에 게시된 임직원용
    <a
      href="https://ghrp.portal.sec.samsung.net/kms/comty.do?comtyId=7146340&menuId=8547254&postId=8547523&page=view&type=LIST"
      >개인정보처리방침</a
    >이 적용됩니다.<br /><br />국외에는 다음과 같이 위탁합니다.<br /> -->
    <div>본 시스템의 개인정보처리방침은 인사시스템에 게시된 임직원용 개인정보처리방침 이 적용됩니다.</div>
    <br />

    <table>
      <thead>
        <tr>
          <th>위탁받는 업체 명칭</th>
          <th>위탁받는 업무 내용</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Amazon Web Services Inc.</td>
          <td>클라우드 서버를 통한 데이터 보관 및 네트워크를 통한 전송</td>
        </tr>
         <tr>
          <td>Samsung R&D Institute India Delhi</td>
          <td>클라우드 서버 인프라 운영 및 관리</td>
        </tr>
      </tbody>
    </table>


    <br />
    <div>서비스 이용에 필수적인 국외이전이므로 거부하시면 서비스 이용이 제한됩니다.</div>
    <br />
    <table>
      <thead>
        <tr>
          <th>업체명칭</th>
          <th>연락처</th>
          <th>이전되는항목</th>
          <th>이전국가, 일시 및 방법</th>
          <th>이전목적 및 보유∙이용 기간 </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Amazon Web Services Inc.</td>
          <td>https://aws.amazon.com/compliance/contact/</td>
          <td>Knox ID</td>
          <td>일본. 서비스 이용 시점에 네트워크를 통한 전송</td>
          <td>개인정보 보관기간 동안 개인정보가 보관된 클라우드 서버를 운영 및 관리에 사용되며, 개인정보 수집, 이용목적 달성시까지 보관됩니다. </td>
        </tr>
         <tr>
          <td>Samsung R&D Institute India Delhi</td>
          <td>{{"info.srid@samsung.com"}}</td>
          <td>Knox ID</td>
          <td>인도. 서비스 이용 시점에 네트워크를 통한 전송</td>
          <td>개인정보 보관기간 동안 개인정보가 보관된 클라우드 서버를 운영 및 관리에 사용되며, 개인정보 수집, 이용목적 달성시까지 보관됩니다.  </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="padding20" *ngIf="popupSettings.component === 'userManagement'">
  <h1>{{ popupSettings.headerText }}</h1>
  <ng-container *ngIf="!popupSettings.isTemplate; else templateRef">
    <div [innerHTML]="sanitizer.bypassSecurityTrustHtml(popupSettings.message)"></div>
    <div class="flex col" *ngIf="popupSettings.showReason">
      <textarea #reason rows="5" cols="60" [formControl]="comSvc.reason" maxlength="250"></textarea>
      <p class="flex end hint">{{ comSvc.reason.value.length }}/250</p>
    </div>
    <div class="mt10">
      <div mat-dialog-actions align="end">
        <button mat-stroked-button color="accent" mat-dialog-close="close">Cancel</button>
        <button
          mat-flat-button
          color="primary"
          [disabled]="popupSettings.showReason && comSvc.reason.value.trim() === ''"
          mat-dialog-close="true">
          Confirm
        </button>
      </div>
    </div>
  </ng-container>
  <ng-template #templateRef>
    <ng-container
      [ngTemplateOutlet]="popupSettings.message"
      [ngTemplateOutletContext]="{ $implicit: data }"></ng-container>
    <div class="mt10">
      <div mat-dialog-actions align="end">
        <button mat-stroked-button color="accent" mat-dialog-close="close">Cancel</button>
        <button
          mat-flat-button
          color="primary"
          [mat-dialog-close]="comSvc.userRole.value"
          [disabled]="disableConfirm()">
          Confirm
        </button>
      </div>
    </div>
  </ng-template>
</div>
